// extracted by mini-css-extract-plugin
export default {"cartaoNovidades":"CartaoNovidades_cartaoNovidades__1NaK9","colunaDescricao":"CartaoNovidades_colunaDescricao__+lTAB","dataInserida":"CartaoNovidades_dataInserida__BBvO1"};